var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMasterData = function SvgMasterData(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "masterData_svg__masterData",
    x: 0,
    y: 0,
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "#masterData_svg__masterData .masterData_svg__st1{fill:#f5cdb0}")), /*#__PURE__*/React.createElement("path", {
    d: "M630.6 674.4c23.6 22.9 282.5 199.8 289.7 212.8 5.3 9.6 8.2 20.5 8.2 31.8v81H488.7h18.5H71.5v-81c0-11.3 2.9-22.3 8.2-31.8 7.2-13 277.8-188 301.4-210.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "masterData_svg__MgvEEA.tif_5_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M381.9 592.2c-32.6-26.9-63.6-55.6-79.5-95.8-8.7-22.1-13.6-45.7-20.2-68.6l.6-69.5c7.2 5.2 14.4 10.3 23.4 16.7 0-37.9.4-73.1-.3-108.3-.2-11.2 3.2-16.1 14.1-19.7 91.3-30 182.4-60.9 273.8-90.6 6.2-2 16.9.6 21.7 5.1 27.1 25.5 53.6 51.8 79.1 79 6.4 6.9 11 18 11.4 27.4 1.3 34.9.5 70 .5 107.7 9.6-7.5 16.8-13 23.9-18.6 0 23.6.1 47.1.1 70.7-10 67.6-41.2 122.1-98.5 160.8-54.9 35.3-114.9 44.5-177.7 31-24.9-5.4-48.3-18-72.4-27.3",
    className: "masterData_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M730.4 357c-7.1 5.5-14.2 11.1-23.9 18.6 0-37.7.8-72.7-.5-107.7-.4-9.4-5-20.6-11.4-27.4-25.4-27.2-51.9-53.5-79.1-79-4.8-4.5-15.5-7.1-21.7-5.1C502.4 186.1 411.3 217 320 247c-10.9 3.6-14.3 8.5-14.1 19.7.7 35.2.3 70.4.3 108.3-8.9-6.4-16.2-11.5-23.4-16.7-8.9-8.4-17.8-16.7-26.7-25.1.9-50.5-2-101.2 13.4-150.7C304 71.5 387.6 6.3 503.5 1.9c9.3-.4 18.9 1 28-.4C566.1-3.9 592 4.4 602.1 42c1.2 4.6 7.4 9.9 12.2 11.1 92.5 22 130.6 87.7 139.2 175.3 3.4 35.1 1.8 70.6 2.5 105.9-8.6 7.6-17.1 15.2-25.6 22.7",
    style: {
      fill: "#444343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.7 703.6h-4.8c-37.2-7.8-74.5-15.6-111.7-23.5-3.8-.8-7.4-2.5-11.1-3.8.3-28.1.5-56.1.8-84.2 24.1 9.3 47.4 22 72.4 27.3 62.8 13.5 122.8 4.3 177.7-31-.8 30.3-1.7 60.6-2.5 90.9-40.3 8.1-80.5 16.2-120.8 24.3",
    style: {
      fill: "#f0b398"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 333.2c8.9 8.4 17.8 16.7 26.7 25.1l-.6 69.5c-24.6-2.4-42.4-13.6-49.2-38.5-6.7-24.6 4.2-42 23.1-56.1M730.4 357c8.5-7.5 17.1-15.1 25.6-22.6 20 11.8 28.9 29.5 24.3 52.1-5.4 26.3-24 38.6-49.8 41.2-.1-23.6-.1-47.1-.1-70.7",
    className: "masterData_svg__st1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M452.8 1000h107.4c-3.7-46.7-24-147.4-25.6-194.2-.5-14.5 15.6-29.5 25.5-46.9-16.4-16.9-35-36.1-53.7-55.3-18.7 19.3-37.3 38.4-53.7 55.3 10 17.4 26 32.4 25.5 46.9",
    style: {
      fill: "#3162ab"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMasterData);
export default ForwardRef;